import { ComponentType } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useDatasetContext } from '../hooks/context/useDatasetContext';
import PageContent from '../layouts/PageContent/PageContent';
import ApiError from '../components/ApiError/ApiError';
import { useTranslate } from '../hooks/context/useTranslate';

// Header + Sidebar live in the persistent shell (AppShell), so a dataset page renders content only.
// The Sidebar reads the current dataset's peersets and the token-chain refresh from context itself.
const withDatasetPageLayout = <P extends RouteComponentProps>(
  Component: ComponentType<P>
) => {
  const WithDatasetPageLayoutWrapper = (props: P) => {
    const { isLoading: isTranslationLoading } = useTranslate();
    const { apiError, isLayoutLoading, isDatasetHookLoading, datasetData } =
      useDatasetContext();

    if (apiError) {
      return (
        <PageContent isLoading={isTranslationLoading}>
          <ApiError error={apiError.error} />
        </PageContent>
      );
    }

    return (
      <PageContent
        isLoading={
          isLayoutLoading ||
          isTranslationLoading ||
          (isDatasetHookLoading && datasetData?.lazy)
        }
      >
        <Component {...props} />
      </PageContent>
    );
  };
  return WithDatasetPageLayoutWrapper;
};

export default withDatasetPageLayout;
